export default {"src":"/_next/static/media/Icon_Hasta.e6230fb2.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};